import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const ModalHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1rem;
`

export const HeadMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const HeadLocation = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const WindowBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  margin-bottom: 1rem;
`

export const WindowLabel = styled.span`
  font-size: ${tokens.font.micro};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${tokens.text.muted};
`

export const WindowValue = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const TypeToggle = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
`

export const ToggleButton = styled.button<{ active?: boolean }>`
  flex: 1;
  padding: 0.625rem 1rem;
  border-radius: ${tokens.radius.control};
  cursor: pointer;
  font-size: ${tokens.font.body};
  font-weight: 600;
  transition: ${tokens.motion.duration} ${tokens.motion.ease};
  background: ${({ active }) => (active ? tokens.accent.soft : tokens.surface.inset)};
  border: 1px solid ${({ active }) => (active ? tokens.accent.glowBorder : tokens.border.hairline)};
  color: ${({ active }) => (active ? tokens.accent.onDark : tokens.text.secondary)};
`

export const FieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const FieldRow = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
`
